import React from "react";
import { Route, Redirect } from "react-router-dom";
import { Auth } from "./fake.auth";

export function ProtectedRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        Auth.isAuthenticated === true ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location.pathname }
            }}
          />
        )
      }
    />
  );
}
